import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import PublicIcon from "@mui/icons-material/Public";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LANGUAGE_CONFIGS } from "../../core/i18n/config";
const SHORT_LABELS = {
    "en-US": "EN",
    "en-GB": "EN",
    "en-IN": "EN",
    hi: "हि",
    te: "తె",
    ur: "ار",
    ar: "ع",
    fr: "FR",
};
export function LanguageSelector({ language, onChange, label, isMobile = false, compact = false, shape = "pill", }) {
    const radius = shape === "rectangular" ? "10px" : "50px";
    return (_jsx(Select, { size: "small", value: language, onChange: (e) => {
            void onChange(e.target.value);
        }, displayEmpty: true, title: label, inputProps: { "aria-label": label }, IconComponent: KeyboardArrowDownIcon, renderValue: (val) => (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 0.5, children: [_jsx(PublicIcon, { sx: { fontSize: 14, color: "text.secondary" } }), _jsx(Typography, { variant: "caption", sx: { fontWeight: 600, lineHeight: 1, color: "text.primary" }, children: SHORT_LABELS[val] ??
                        val.toUpperCase().slice(0, 2) })] })), sx: {
            flexShrink: 0,
            borderRadius: radius,
            bgcolor: "background.paper",
            fontSize: 12,
            height: compact ? (isMobile ? 30 : 34) : isMobile ? 32 : 36,
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "divider",
                borderRadius: radius,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "text.disabled",
            },
            "& .MuiSelect-select": {
                py: "0 !important",
                pl: "10px !important",
                pr: "28px !important",
                display: "flex",
                alignItems: "center",
            },
            "& .MuiSvgIcon-root.MuiSelect-icon": { fontSize: 16, right: 4 },
        }, children: LANGUAGE_CONFIGS.map((lang) => {
            const isRtl = lang.direction === "rtl";
            return (_jsx(MenuItem, { value: lang.code, lang: lang.code, dir: lang.direction ?? "ltr", sx: { fontSize: 13 }, children: _jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1.25, sx: {
                        width: "100%",
                        flexDirection: isRtl ? "row-reverse" : "row",
                        justifyContent: isRtl ? "flex-end" : "flex-start",
                    }, children: [_jsx(Typography, { variant: "caption", sx: {
                                fontWeight: 700,
                                minWidth: 22,
                                color: "text.secondary",
                                fontFamily: "monospace",
                            }, children: SHORT_LABELS[lang.code] ?? lang.code.slice(0, 2).toUpperCase() }), _jsx(Typography, { variant: "body2", children: lang.nativeName }), lang.nativeName !== lang.name && (_jsx(Typography, { variant: "caption", sx: { color: "text.secondary" }, children: lang.name }))] }) }, lang.code));
        }) }));
}
